const MainAddress = "https://www.sabaapi.ir/webapi/reciept/web/";
// const MainAddress ="https://www.sabaapi.com/webapi/";
export default MainAddress;